import React from 'react';
import { useTranslation } from 'react-i18next';

const LANGUAGES = [
    { code: 'en', label: 'EN' },
    { code: 'fr', label: 'FR' }
];

export function LanguageSwitcher() {
    const { i18n } = useTranslation();

    return (
        <div className="flex items-center gap-1">
            {LANGUAGES.map((lang, idx) => (
                <React.Fragment key={lang.code}>
                    {idx > 0 && <span className="text-white/30 text-xs">/</span>}
                    <button
                        onClick={() => i18n.changeLanguage(lang.code)}
                        className={`text-xs font-semibold transition-colors ${
                            i18n.language?.startsWith(lang.code)
                                ? 'text-white'
                                : 'text-white/50 hover:text-white/80'
                        }`}
                    >
                        {lang.label}
                    </button>
                </React.Fragment>
            ))}
        </div>
    );
}
